import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { BsMouse } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import './Hero.scss';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [fadeState, setFadeState] = useState('fade-in');
  const { t } = useTranslation();
  
  const slides = [
    {
      image: 'textile-bg.png',
      subtitle: t('hero.global_partner'),
      title: t('hero.reliable_production'),
      description: t('hero.global_partner_desc')
    },
    {
      image: 'textile-bg-2.png',
      subtitle: t('hero.innovation'),
      title: t('hero.premium_solutions'),
      description: t('hero.innovation_desc')
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeState('fade-out');
      setTimeout(() => {
        setCurrentSlide((prev) => (prev === 0 ? 1 : 0));
        setFadeState('fade-in');
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleScrollClick = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  return (
    <div className="hero">
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide ${currentSlide === index ? 'active' : ''}`}
            style={{ backgroundImage: `url(${require(`../../assets/images/${slide.image}`)})` }}
          />
        ))}
      </div>
      <Container>
        <div className="hero-content">
          <div className={`content-wrapper ${fadeState}`}>
            <span className='sub-title'>
              {slides[currentSlide].subtitle}
            </span>
            <h1>
              {slides[currentSlide].title}
            </h1>
            <p>{slides[currentSlide].description}</p>
          </div>
        </div>
      </Container>
      <div className="scroll-indicator" onClick={handleScrollClick}>
        <BsMouse size={32} />
      </div>
    </div>
  );
};

export default Hero;